import {
  STANDARD_NUMBER_WIDTH,
  STANDARD_NUMBER_HEIGHT,
  LARGE_NUMBER_HEIGHT,
  LARGE_NUMBER_WIDTH,
} from '@Animation/constants'
import { PLINKO_ATLAS_FRAMES, PLINKO_TEXTURE_KEYS } from './constants'

export const PlinkoTextureLoader = (scene: Phaser.Scene) => {
  if (!scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.NUMBER_DEFAULT)) {
    scene.textures.addSpriteSheetFromAtlas(PLINKO_TEXTURE_KEYS.NUMBER_DEFAULT, {
      atlas: PLINKO_TEXTURE_KEYS.ATLAS,
      frame: PLINKO_ATLAS_FRAMES.NUMBER_DEFAULT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(PLINKO_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED, {
      atlas: PLINKO_TEXTURE_KEYS.ATLAS,
      frame: PLINKO_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }

  if (!scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED)) {
    scene.textures.addSpriteSheetFromAtlas(PLINKO_TEXTURE_KEYS.NUMBER_PLAYER_SELECTED, {
      atlas: PLINKO_TEXTURE_KEYS.ATLAS,
      frame: PLINKO_ATLAS_FRAMES.NUMBER_PLAYER_SELECTED,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }
  if (!scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.NUMBER_HIT)) {
    scene.textures.addSpriteSheetFromAtlas(PLINKO_TEXTURE_KEYS.NUMBER_HIT, {
      atlas: PLINKO_TEXTURE_KEYS.ATLAS,
      frame: PLINKO_ATLAS_FRAMES.NUMBER_HIT,
      frameWidth: STANDARD_NUMBER_WIDTH,
      frameHeight: STANDARD_NUMBER_HEIGHT,
    })
  }
  if (!scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.NUMBER_HIT_TRANSITION)) {
    scene.textures.addSpriteSheetFromAtlas(PLINKO_TEXTURE_KEYS.NUMBER_HIT_TRANSITION, {
      atlas: PLINKO_TEXTURE_KEYS.ATLAS,
      frame: PLINKO_ATLAS_FRAMES.NUMBER_HIT_TRANSITION,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }
  if (
    !scene.textures.getTextureKeys().includes(PLINKO_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION)
  ) {
    scene.textures.addSpriteSheetFromAtlas(PLINKO_TEXTURE_KEYS.NUMBER_SYSTEM_SELECTED_TRANSITION, {
      atlas: PLINKO_TEXTURE_KEYS.ATLAS,
      frame: PLINKO_ATLAS_FRAMES.NUMBER_SYSTEM_SELECTED_TRANSITION,
      frameWidth: LARGE_NUMBER_WIDTH,
      frameHeight: LARGE_NUMBER_HEIGHT,
    })
  }
}
